<template>
    <div class="object-group-detail argus-glass-page">
        <router-link to="/objects/groups">← Группы строительных объектов</router-link>
        <div v-if="loading && !card" class="py-4" role="status">Загрузка группы объектов…</div>
        <b-alert :show="!!error" variant="danger">{{ error }} <b-button size="sm" variant="link" @click="load">Повторить</b-button></b-alert>
        <template v-if="card">
            <header class="argus-glass-surface p-3 mb-3">
                <h1>{{ card.name }}</h1><b-badge :variant="card.archived ? 'secondary' : 'success'">{{ card.archived ? 'Архивная' : 'Действующая' }}</b-badge>
                <p class="mt-2 mb-0">{{ card.description || 'Группа строительных объектов' }}</p>
                <router-link v-if="card.permissions.can_manage" to="/objects/groups" class="d-inline-block mt-2">Изменить название и состав</router-link>
            </header>
            <section class="argus-glass-surface p-3 mb-3">
                <h2>Общие дополнительные Telegram-группы</h2>
                <p>ИТР, Снабжение, Механики и произвольные группы для входящих объектов. Основная Telegram-группа у каждого объекта остаётся своей.</p>
                <p v-if="!card.telegram_groups.length" class="text-muted">Общие Telegram-группы не привязаны.</p>
                <ObjectTelegramGroups :key="card.id" :card="card" @changed="telegramChanged"/>
            </section>
            <section class="argus-glass-surface p-3">
                <h2>Доступные объекты</h2>
                <p v-if="!card.objects.length" class="text-muted">В группе пока нет объектов.</p>
                <div v-for="object in card.objects" :key="object.building_id" class="object-group-detail__member">
                    <router-link :to="`/objects/${object.building_id}`">{{ object.name }}</router-link>
                    <b-button v-if="card.permissions.can_manage" size="sm" variant="link" @click="$refs.membership.open({...object,object_group_id:card.id})">Изменить группу</b-button>
                </div>
            </section>
        </template>
        <ObjectGroupMembership ref="membership" @changed="load"/>
    </div>
</template>
<script>
import api from '@/utils/api';
import ObjectTelegramGroups from './components/ObjectTelegramGroups.vue';
import ObjectGroupMembership from './components/ObjectGroupMembership.vue';
export default {
    components:{ObjectTelegramGroups,ObjectGroupMembership},
    data:()=>({card:null,loading:false,error:''}),
    watch:{'$route.params.id':{immediate:true,handler(){this.card=null;this.load();}}},
    methods:{
        telegramChanged(data){this.card={...this.card,telegram_groups:data.groups};},
        async load(){
            const id=this.$route.params.id; this.loading=true;this.error='';
            try{const {data}=await api.get(`/api/object-groups/${id}`,{ignoreModal:true});if(id===this.$route.params.id)this.card=data;}
            catch(error){if(id===this.$route.params.id)this.error=error.response && error.response.data && (error.response.data.message || error.response.data.msg) || 'Не удалось загрузить группу объектов';}
            finally{if(id===this.$route.params.id)this.loading=false;}
        }
    }
};
</script>
<style scoped>
.object-group-detail {padding:20px;min-height:100%;}.object-group-detail h1 {font-size:26px;overflow-wrap:anywhere;}.object-group-detail h2 {font-size:19px;}.object-group-detail section,.object-group-detail header {border-radius:14px;}.object-group-detail__member {display:flex;justify-content:space-between;gap:12px;padding:10px 0;border-bottom:1px solid #e0e6ed;overflow-wrap:anywhere;}
@media(max-width:575.98px){.object-group-detail{padding:12px;}.object-group-detail__member{display:block;}}
</style>
